import { PolygonElevationPoints } from '../../../../../../../../core/types/types';

export const generateHighestLowestElevationPointsObject = (highestAndLowestElevationPoints: PolygonElevationPoints) => {
    return {
        highest: {
            lat: highestAndLowestElevationPoints.highest.latitude,
            lng: highestAndLowestElevationPoints.highest.longitude,
            elevation: highestAndLowestElevationPoints.highest.elevation,
            color: 'red',
        },
        lowest: {
            lat: highestAndLowestElevationPoints.lowest.latitude,
            lng: highestAndLowestElevationPoints.lowest.longitude,
            elevation: highestAndLowestElevationPoints.lowest.elevation,
            color: 'green',
        },
    };
};
